import {
  getString,
  getLeoUuid,
  LeoUUID,
  getLeoTimestamp,
  LeoTimestamp,
} from "@surya-digital/leo-ts-types";

export interface GetBOUsersPaginationResponseDTO {
  firstName: string;
  lastName: string;
  emailAddress: string;
  boUserId: string;
  role: string;
  addedOn: string;
}

export class GetBOUsersPaginationResponse {
  readonly isGetBOUsersPaginationResponseGetBOUsersPaginationResponse: boolean = true;

  readonly firstName: string;
  readonly lastName: string;
  readonly emailAddress: string;
  readonly boUserId: LeoUUID;
  readonly role: string;
  readonly addedOn: LeoTimestamp;


  constructor(
  firstName: string, 
  lastName: string, 
  emailAddress: string, 
  boUserId: LeoUUID, 
  role: string, 
  addedOn: LeoTimestamp
  ) {
    GetBOUsersPaginationResponse.validateFirstName(firstName);
    this.firstName = firstName;
    GetBOUsersPaginationResponse.validateLastName(lastName);
    this.lastName = lastName;
    GetBOUsersPaginationResponse.validateEmailAddress(emailAddress);
    this.emailAddress = emailAddress;
    this.boUserId = boUserId;
    GetBOUsersPaginationResponse.validateRole(role);
    this.role = role;
    this.addedOn = addedOn;
  }

  static fromDTO(dto: GetBOUsersPaginationResponseDTO): GetBOUsersPaginationResponse {
    const firstName = getString(dto, "firstName", InvalidGetBOUsersPaginationResponseFirstNameError);
    const lastName = getString(dto, "lastName", InvalidGetBOUsersPaginationResponseLastNameError);
    const emailAddress = getString(dto, "emailAddress", InvalidGetBOUsersPaginationResponseEmailAddressError);
    const boUserId = getLeoUuid(dto, "boUserId", InvalidGetBOUsersPaginationResponseBoUserIdError);
    const role = getString(dto, "role", InvalidGetBOUsersPaginationResponseRoleError);
    const addedOn = getLeoTimestamp(dto, "addedOn", InvalidGetBOUsersPaginationResponseAddedOnError);
    return new GetBOUsersPaginationResponse(
      firstName,
      lastName,
      emailAddress,
      boUserId,
      role,
      addedOn
    );
  }

  toDTO(): GetBOUsersPaginationResponseDTO {
    const dto: GetBOUsersPaginationResponseDTO = {
        firstName: this.firstName,
        lastName: this.lastName,
        emailAddress: this.emailAddress,
        boUserId: this.boUserId.toDTO(),
        role: this.role,
        addedOn: this.addedOn.toDTO()
    };
    return dto;
  }
  private static validateFirstName = (firstName: string): void => {
    if(firstName.trim().length === 0) {
      throw new InvalidGetBOUsersPaginationResponseFirstNameNonEmptyError(
        `Attribute firstName cannot be an empty string.`
      );
    }
  }
  private static validateLastName = (lastName: string): void => {
    if(lastName.trim().length === 0) {
      throw new InvalidGetBOUsersPaginationResponseLastNameNonEmptyError(
        `Attribute lastName cannot be an empty string.`
      );
    }
  }
  private static validateEmailAddress = (emailAddress: string): void => {
    if(emailAddress.trim().length === 0) {
      throw new InvalidGetBOUsersPaginationResponseEmailAddressNonEmptyError(
        `Attribute emailAddress cannot be an empty string.`
      );
    }
  }
  private static validateRole = (role: string): void => {
    if(role.trim().length === 0) {
      throw new InvalidGetBOUsersPaginationResponseRoleNonEmptyError(
        `Attribute role cannot be an empty string.`
      );
    }
  }
  
}

GetBOUsersPaginationResponse.prototype.toString = function toString(): string {
  return `GetBOUsersPaginationResponse(firstName='${this.firstName}',lastName='${this.lastName}',emailAddress='${this.emailAddress}',boUserId='${this.boUserId}',role='${this.role}',addedOn='${this.addedOn}')`;
};

export class InvalidGetBOUsersPaginationResponseError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetBOUsersPaginationResponseError";
  }
}
export class InvalidGetBOUsersPaginationResponseFirstNameError extends InvalidGetBOUsersPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetBOUsersPaginationResponseFirstNameError";
  }
}

export class InvalidGetBOUsersPaginationResponseFirstNameNonEmptyError extends InvalidGetBOUsersPaginationResponseFirstNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetBOUsersPaginationResponseFirstNameNonEmptyError";
  }
}

export class InvalidGetBOUsersPaginationResponseLastNameError extends InvalidGetBOUsersPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetBOUsersPaginationResponseLastNameError";
  }
}

export class InvalidGetBOUsersPaginationResponseLastNameNonEmptyError extends InvalidGetBOUsersPaginationResponseLastNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetBOUsersPaginationResponseLastNameNonEmptyError";
  }
}

export class InvalidGetBOUsersPaginationResponseEmailAddressError extends InvalidGetBOUsersPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetBOUsersPaginationResponseEmailAddressError";
  }
}

export class InvalidGetBOUsersPaginationResponseEmailAddressNonEmptyError extends InvalidGetBOUsersPaginationResponseEmailAddressError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetBOUsersPaginationResponseEmailAddressNonEmptyError";
  }
}

export class InvalidGetBOUsersPaginationResponseBoUserIdError extends InvalidGetBOUsersPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetBOUsersPaginationResponseBoUserIdError";
  }
}

export class InvalidGetBOUsersPaginationResponseRoleError extends InvalidGetBOUsersPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetBOUsersPaginationResponseRoleError";
  }
}

export class InvalidGetBOUsersPaginationResponseRoleNonEmptyError extends InvalidGetBOUsersPaginationResponseRoleError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetBOUsersPaginationResponseRoleNonEmptyError";
  }
}

export class InvalidGetBOUsersPaginationResponseAddedOnError extends InvalidGetBOUsersPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetBOUsersPaginationResponseAddedOnError";
  }
}
